import React from 'react';

const ScoreLine = () => (
  <div className="score-write-bl">
    <span className="score-line"/>
  </div>
);

export default ScoreLine;
